import { render, staticRenderFns } from "./DefaultProductList.vue?vue&type=template&id=64a4a2fc"
import script from "./DefaultProductList.vue?vue&type=script&lang=js"
export * from "./DefaultProductList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports